module.exports = __webpack_public_path__ + "static/media/chiragShahsir.fb1a8699.png";